import React, { Fragment, useState } from 'react';
import Modal from '../../partials/Modal/Modal';
import './MultiTabs.scss';

const MultiTabs = props => {

  const { data } = props;

  const [ source, setSource ] = useState(data);
  const [ currentTab, setCurrentTab ] = useState(0);
  const [ modalVisibility, setModalVisibility ] = useState(false);
  const [ modalData, setModalData ] = useState({
    header: 'Header here',
    body: 'content of the modal',
    button: 'Next',
    onClose: () => { } 
  });

  const changeSubTab = (subTab) => {
    let newData = source.tabs;
    const currentSubTab = newData[currentTab].subTabs[subTab];
    currentSubTab.active = true;
    currentSubTab.readed = true;
    newData[currentTab].subTabs.forEach( (item, index) => {
      if(index !== subTab) {
        item.active = false;
      } 
    });
    setSource({
      ...source,
      tabs: newData
    });
  }

  const clearModal = () => {
    setModalVisibility(false);
    setModalData({});
  }

  return (
    <div className="multi-tabs">
      <ul className="nav-tabs">
        {
          source.tabs.map( (tab, tabIndex) => (
            tab.visible && <li key={`nav-tab-item-${tabIndex}}`} className={`nav-tab-item ${currentTab === tabIndex ? 'active' : ''}`} onClick={() => { setCurrentTab(tabIndex) }}>{tab.title}</li>
          ))
        }
      </ul>
      <div className="tab-content">
        <ul className="subtab-list">
          {
            source.tabs[currentTab].subTabs.map( (subTab, subTabIndex) => (
              <li key={`subtab-item-${subTabIndex}}`} className={`subtab-item ${subTab.active ? 'active' : ''}`} onClick={ () => { changeSubTab(subTabIndex) } }>{subTab.title}</li>
            ))
          }
        </ul>
        <div className="subtab-body">
          {
            source.tabs[currentTab].subTabs.map( (subTab, subTabIndex) => (
              subTab.active &&
              <Fragment key={`subtab-body-element-${subTabIndex}}`}>
                <div dangerouslySetInnerHTML={{ __html: subTab.body }}></div>
                {
                  subTab.images.length > 0 &&
                  <div className="image-list">
                  {
                    subTab.images.map( (image, imageIndex) => (
                      <div className="image-item" key={`image-item-${imageIndex}`}>
                        { image.showInPopup ?
                          <>
                            <img src={image.url} 
                              width="100%"
                              alt={subTab.title}  
                              onClick={ () => {
                                setModalData({
                                  header: 'Image detail',
                                  body: (
                                    <img src={image.url} style={{ height: '500px', display: 'block', margin: '0 auto' }} alt={subTab.title} />
                                  ),
                                  button: 'Close',
                                  onClose: () => { clearModal() },
                                  size: 'lg'
                                });
                                setModalVisibility(true);
                               } }/>
                            <span>{image.showInPopupText}</span>
                          </>
                          :
                          <img src={image.url} width="100%" alt={subTab.title} />
                        }
                      </div>
                    ))
                  }
                  </div>
                }
                {
                  subTab.audios.length > 0 &&
                  <div className="audio-list">
                  {
                    subTab.audios.map( (audio, audioIndex) => (
                      <div className="audio-item" key={`audio-item-${audioIndex}`}>
                        <audio controls width="100%">
                          <source src={audio.url} type={`audio/${audio.extension}`} />
                        </audio>
                      </div>
                    ))
                  }
                  </div>
                }
                {
                  subTab.videos.length > 0 &&
                  <div className="video-list">
                  {
                    subTab.videos.map( (video, videoIndex) => (
                      <div className="video-item" key={`video-item-${videoIndex}`}>
                        { video.showInPopup ?
                          <>
                            <img src={video.thumbnail} alt={subTab.title} />
                            <div className="play-indicator" 
                              onClick={ () => {
                                setModalData({
                                  header: video.title,
                                  body: (
                                    <video width="100%" controls id="video-player" autoPlay={video.autoPlay}> 
                                      <source src={video.url} type="video/mp4" />
                                      Your browser does not support the video tag.
                                    </video>
                                  ),
                                  button: 'Close',
                                  onClose: () => { clearModal() },
                                  size: 'lg'
                                });
                                setModalVisibility(true);
                               } }></div>
                          </>
                          :
                          <video width="100%" controls id="video-player" autoPlay={video.autoPlay}> 
                            <source src={video.url} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        }
                      </div>
                    ))
                  }
                  </div>
                }
              </Fragment>
            ))
          }
        </div>
      </div>
      <Modal {...modalData} visible={modalVisibility} onClose={clearModal} />
    </div>
  );

};

export default MultiTabs;